import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import type { ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { DovetailIcon, DovetailSearchResultIcon } from './icon';

export const dovetailConfig: ThirdPartyConfig = {
	displayName: 'Dovetail',
	id: 'dovetail',
	resourceType: ProductResourceTypes3P.Dovetail,
	icon: get3PLogo(DovetailIcon, 'Dovetail', 'medium'),
	searchResultIcon: get3PLogo(DovetailSearchResultIcon, 'Dovetail', 'large'),
	integrationAri: 'ari:cloud:platform::integration/dovetail',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
